// extracted by mini-css-extract-plugin
export var aniSpin = "C_d";
export var item = "C_l";
export var item__inner = "C_4";
export var item__quote = "C_1";
export var item__source = "C_3";
export var item__stars = "C_2";
export var items = "C_0";